import { AbstractControl, FormArray, ValidatorFn } from '@angular/forms';

import { FeedAdviceType } from '../models/feed-advice.model';

const isEmptyObject = (obj: unknown): boolean =>
  obj && Object.keys(obj).length === 0 && obj.constructor === Object;

export const connectingDayValidator =
  (
    element: string,
    dayFromArray: FormArray,
    dayToArray: FormArray,
    feedAdviceType: FeedAdviceType,
  ): ValidatorFn =>
  (control: AbstractControl): { [key: string]: boolean } | null => {
    if (element === 'dayFrom') {
      const index = dayFromArray.controls.findIndex((x) => x === control) as number;
      if (index >= 1) {
        const previousDayToControl = dayToArray.controls[index - 1];
        if (!!previousDayToControl && !!previousDayToControl.value && !!control.value) {
          let previousDayToErrors = previousDayToControl.errors
            ? Object.assign({}, previousDayToControl.errors)
            : {};
          let dayFromErrors = control.errors ? Object.assign({}, control.errors) : {};
          if (
            (control.value as number) === (previousDayToControl.value as number) + 1 ||
            (feedAdviceType === FeedAdviceType.SOWS_FARROWTOWEAN &&
              (control.value as number) === 1) ||
            (dayFromArray.controls.some((x) => x.value === 1) &&
              (control.value as number) === (previousDayToControl.value as number) + 1)
          ) {
            if (Object.prototype.hasOwnProperty.call(dayFromErrors, 'connectingDay')) {
              delete dayFromErrors.connectingDay;
            }
            if (Object.prototype.hasOwnProperty.call(previousDayToErrors, 'connectingDay')) {
              delete previousDayToErrors.connectingDay;
            }
            control.setErrors(isEmptyObject(dayFromErrors) ? null : dayFromErrors);
            previousDayToControl.setErrors(
              isEmptyObject(previousDayToErrors) ? null : previousDayToErrors,
            );
            return null;
          } else {
            dayFromErrors = { ...dayFromErrors, connectingDay: false };
            previousDayToErrors = { ...previousDayToErrors, connectingDay: false };
            control.setErrors(dayFromErrors);
            previousDayToControl.setErrors(previousDayToErrors);
            return dayFromErrors;
          }
        }
      }
    } else if (element === 'dayTo') {
      const index = dayToArray.controls.findIndex((x) => x === control) as number;
      if (index >= 0 && index < dayFromArray.controls.length) {
        const nextDayFromControl = dayFromArray.controls[index + 1];
        if (!!nextDayFromControl && !!nextDayFromControl.value && !!control.value) {
          let dayToErrors = control.errors ? Object.assign({}, control.errors) : {};
          let nextDayFromErrors = nextDayFromControl.errors
            ? Object.assign({}, nextDayFromControl.errors)
            : {};
          if (
            (control.value as number) === (nextDayFromControl.value as number) - 1 ||
            (feedAdviceType === FeedAdviceType.SOWS_FARROWTOWEAN &&
              (nextDayFromControl.value as number) === 1)
          ) {
            if (Object.prototype.hasOwnProperty.call(dayToErrors, 'connectingDay')) {
              delete dayToErrors.connectingDay;
            }
            if (Object.prototype.hasOwnProperty.call(nextDayFromErrors, 'connectingDay')) {
              delete nextDayFromErrors.connectingDay;
            }
            control.setErrors(isEmptyObject(dayToErrors) ? null : dayToErrors);
            nextDayFromControl.setErrors(
              isEmptyObject(nextDayFromErrors) ? null : nextDayFromErrors,
            );
            return null;
          } else {
            dayToErrors = { ...dayToErrors, connectingDay: false };
            nextDayFromErrors = { ...nextDayFromErrors, connectingDay: false };
            control.setErrors(dayToErrors);
            nextDayFromControl.setErrors(nextDayFromErrors);
            return dayToErrors;
          }
        }
      }
    }
  };
